import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MetaPreviewData } from '../../../../../../../models/meta-template/preview-interfaces/meta-preview-data.interface';
import { MetaCreativeComponent } from '../../../preview-common/meta-creative/meta-creative.component';
import { MetaPreviewCopy, TruncatedCopy } from '../../../preview-common/meta-preview-copy';

/**
 * Facebook in-stream reels, full screen: the creative letterboxed in a black
 * player, with the page, one line of copy and a white button beneath it.
 */
@Component({
  selector: 'app-meta-facebook-in-stream-reels-fullscreen',
  imports: [CommonModule, MetaCreativeComponent],
  templateUrl: './facebook-in-stream-reels-fullscreen.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [
    '../../../preview-common/story/meta-story-styles.scss',
    './facebook-in-stream-reels-fullscreen.component.scss',
  ]
})
export class MetaFacebookInStreamReelsFullscreenPreviewComponent {
  @Input() data!: MetaPreviewData;

  readonly pageName = MetaPreviewCopy.FACEBOOK_PAGE_NAME;
  readonly avatar = MetaPreviewCopy.AVATAR;

  /** One line before "... more", cut mid-word at 42 characters as on the mock. */
  get primaryText(): TruncatedCopy {
    return MetaPreviewCopy.cut(MetaPreviewCopy.primaryText(this.data), 42);
  }

  get cta(): string {
    return MetaPreviewCopy.cta(this.data);
  }
}
